// Loader de marca InnovaCall — logo + barra animada. Reemplaza los "Cargando...".
export default function Loader({ text = 'Cargando…', full = false }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 16, padding: 40, minHeight: full ? '65vh' : 220,
    }}>
      <div style={{
        width: 52, height: 52, borderRadius: 14, overflow: 'hidden',
        background: 'linear-gradient(135deg,#7c3aed,#6d28d9)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 8px 30px rgba(124,58,237,0.5)',
        animation: 'icPulse 1.4s ease-in-out infinite',
      }}>
        <img src="/logo.png" alt="InnovaCall" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onError={e => { e.target.style.display = 'none'; }} />
      </div>
      <div style={{ width: 160, height: 4, borderRadius: 4, background: 'var(--surface-2)', overflow: 'hidden' }}>
        <div className="ic-loadbar" style={{ height: '100%', borderRadius: 4,
          background: 'linear-gradient(90deg,var(--accent-solid),var(--accent))' }} />
      </div>
      <div style={{ fontSize: 13, color: 'var(--text-3)', fontWeight: 500 }}>{text}</div>
    </div>
  );
}
